module.exports = __webpack_public_path__ + "media/images/photo/top/album/album4-e22735a55bff6170cdfeb1c756ef92f2.jpg";